import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

const ProgramCard = ({ board, affiliation, examMode, id, path }) => {
  return (
    <div className="programCard">
      <div
        className="w-full radius-6 flex-col align-start justify-center g-05 p-2"
        style={{ background: "#B6B3FF", height: "90%" }}
      >
        <div className="flex-row align-start justify-start g-05">
          <span className="t-11 poppins color-white">Board:</span>
          <span className="t-11 poppins color-white">{board}</span>
        </div>
        <div className="flex-row align-start justify-start g-05">
          <span className="t-11 poppins color-white">Affiliation:</span>
          <span className="t-11 poppins color-white">{affiliation}</span>
        </div>
        <div className="flex-row align-start justify-start g-05">
          <span className="t-11 poppins color-white">Mode:</span>
          <span className="t-11 poppins color-white">{examMode}</span>
        </div>
      </div>
      <Link
        className="transparentCardBtn t-14 w-full pt-05 pb-05 radius-6 poppins color-white flex align-center justify-center"
        style={{
          background: "#67CABF",
          textDecoration: "none",
          borderBottom: "none",
        }}
        to={`${path}/${id}`}
        state={"academic"}
      >
        Class: 5 (view)
      </Link>
    </div>
  );
};

ProgramCard.propTypes = {
  board: PropTypes.string.isRequired,
  affiliation: PropTypes.string.isRequired,
  examMode: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
};

export default ProgramCard;
